import {useQuery} from 'react-query';
import {LogVO, UserLayersApi} from '../api';
import {LayerId} from '@mc/react-mapio';
import {useMapioContext} from '../mapioContext';

export const CACHE_KEY_DATA_LOG = 'CACHE_KEY_DATA_LOG';

export const useDataLog = (layerId: LayerId, featureId: string, enabledQ: boolean) => {
    const mapioContext = useMapioContext();
    const {context} = mapioContext.value;

    return useQuery<LogVO[]>([CACHE_KEY_DATA_LOG, layerId, featureId], async () => (await UserLayersApi.getDataLog(Number(layerId), featureId, context)).data, {
        enabled: !!enabledQ && Boolean(layerId && featureId),
        refetchOnWindowFocus: true,
        refetchOnReconnect: false,
        refetchOnMount: false,
    });
};
